import React from 'react'

const EnglishLogo = (): JSX.Element => {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.5"
                y="0.5"
                width="21"
                height="21"
                rx="10.5"
                stroke="white"
            />
            <mask
                id="mask0_483_2479"
                maskUnits="userSpaceOnUse"
                x="1"
                y="1"
                width="20"
                height="20"
            >
                <circle cx="11" cy="11" r="10" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_483_2479)">
                <path
                    d="M1.05222 2.63574L1.21815 2.96943L1.58687 3.02474L1.31954 3.28469L1.38223 3.65157L1.05222 3.47827L0.722218 3.65157L0.7849 3.28469L0.517578 3.02474L0.886298 2.96943L1.05222 2.63574Z"
                    fill="white"
                />
                <path
                    d="M3.56882 2.63574L3.7329 2.96943L4.10162 3.02474L3.83615 3.28469L3.89883 3.65157L3.56882 3.47827L3.23698 3.65157L3.29966 3.28469L3.03418 3.02474L3.4029 2.96943L3.56882 2.63574Z"
                    fill="white"
                />
                <path
                    d="M6.08347 2.63574L6.2494 2.96943L6.61812 3.02474L6.35079 3.28469L6.41348 3.65157L6.08347 3.47827L5.75347 3.65157L5.81615 3.28469L5.54883 3.02474L5.91939 2.96943L6.08347 2.63574Z"
                    fill="white"
                />
                <path
                    d="M8.60007 2.63574L8.76415 2.96943L9.13472 3.02474L8.8674 3.28469L8.93008 3.65157L8.60007 3.47827L8.27007 3.65157L8.33275 3.28469L8.06543 3.02474L8.43415 2.96943L8.60007 2.63574Z"
                    fill="white"
                />
                <path
                    d="M1.05222 4.80371L1.21815 5.1374L1.58687 5.19271L1.31954 5.45266L1.38223 5.81953L1.05222 5.64624L0.722218 5.81953L0.7849 5.45266L0.517578 5.19271L0.886298 5.1374L1.05222 4.80371Z"
                    fill="white"
                />
                <path
                    d="M3.56882 4.80371L3.7329 5.1374L4.10162 5.19271L3.83615 5.45266L3.89883 5.81953L3.56882 5.64624L3.23698 5.81953L3.29966 5.45266L3.03418 5.19271L3.4029 5.1374L3.56882 4.80371Z"
                    fill="white"
                />
                <path
                    d="M6.08347 4.80371L6.2494 5.1374L6.61812 5.19271L6.35079 5.45266L6.41348 5.81953L6.08347 5.64624L5.75347 5.81953L5.81615 5.45266L5.54883 5.19271L5.91939 5.1374L6.08347 4.80371Z"
                    fill="white"
                />
                <path
                    d="M8.60007 4.80371L8.76415 5.1374L9.13472 5.19271L8.8674 5.45266L8.93008 5.81953L8.60007 5.64624L8.27007 5.81953L8.33275 5.45266L8.06543 5.19271L8.43415 5.1374L8.60007 4.80371Z"
                    fill="white"
                />
                <path
                    d="M1.05222 6.97168L1.21815 7.30537L1.58687 7.35884L1.31954 7.62063L1.38223 7.9875L1.05222 7.8142L0.722218 7.9875L0.7849 7.62063L0.517578 7.35884L0.886298 7.30537L1.05222 6.97168Z"
                    fill="white"
                />
                <path
                    d="M3.56882 6.97168L3.7329 7.30537L4.10162 7.35884L3.83615 7.62063L3.89883 7.9875L3.56882 7.8142L3.23698 7.9875L3.29966 7.62063L3.03418 7.35884L3.4029 7.30537L3.56882 6.97168Z"
                    fill="white"
                />
                <path
                    d="M6.08347 6.97168L6.2494 7.30537L6.61812 7.35884L6.35079 7.62063L6.41348 7.9875L6.08347 7.8142L5.75347 7.9875L5.81615 7.62063L5.54883 7.35884L5.91939 7.30537L6.08347 6.97168Z"
                    fill="white"
                />
                <path
                    d="M8.60007 6.97168L8.76415 7.30537L9.13472 7.35884L8.8674 7.62063L8.93008 7.9875L8.60007 7.8142L8.27007 7.9875L8.33275 7.62063L8.06543 7.35884L8.43415 7.30537L8.60007 6.97168Z"
                    fill="white"
                />
                <path
                    d="M1.05222 9.13965L1.21815 9.47518L1.58687 9.52865L1.31954 9.7886L1.38223 10.1555L1.05222 9.98217L0.722218 10.1555L0.7849 9.7886L0.517578 9.52865L0.886298 9.47518L1.05222 9.13965Z"
                    fill="white"
                />
                <path
                    d="M3.56882 9.13965L3.7329 9.47518L4.10162 9.52865L3.83615 9.7886L3.89883 10.1555L3.56882 9.98217L3.23698 10.1555L3.29966 9.7886L3.03418 9.52865L3.4029 9.47518L3.56882 9.13965Z"
                    fill="white"
                />
                <path
                    d="M6.08347 9.13965L6.2494 9.47518L6.61812 9.52865L6.35079 9.7886L6.41348 10.1555L6.08347 9.98217L5.75347 10.1555L5.81615 9.7886L5.54883 9.52865L5.91939 9.47518L6.08347 9.13965Z"
                    fill="white"
                />
                <path
                    d="M8.60007 9.13965L8.76415 9.47518L9.13472 9.52865L8.8674 9.7886L8.93008 10.1555L8.60007 9.98217L8.27007 10.1555L8.33275 9.7886L8.06543 9.52865L8.43415 9.47518L8.60007 9.13965Z"
                    fill="white"
                />
                <path d="M26.0384 1H-4.03809V20.9975H26.0384V1Z" fill="white" />
                <path
                    d="M11.1735 1H-4.03809V11.7906H11.1735V1Z"
                    fill="#233CAF"
                />
                <path
                    d="M26.0369 1H11.1738V2.58365H26.0369V1Z"
                    fill="#EB0000"
                />
                <path
                    d="M26.0369 4.06934H11.1738V5.65299H26.0369V4.06934Z"
                    fill="#EB0000"
                />
                <path
                    d="M26.0369 7.1377H11.1738V8.72135H26.0369V7.1377Z"
                    fill="#EB0000"
                />
                <path
                    d="M26.0369 10.207H11.1738V11.7925H26.0369V10.207Z"
                    fill="#EB0000"
                />
                <path
                    d="M26.0384 13.2764H-4.03809V14.8619H26.0384V13.2764Z"
                    fill="#EB0000"
                />
                <path
                    d="M26.0384 16.3447H-4.03809V17.9284H26.0384V16.3447Z"
                    fill="#EB0000"
                />
                <path
                    d="M26.0384 19.4141H-4.03809V20.9977H26.0384V19.4141Z"
                    fill="#EB0000"
                />
                <path
                    d="M2.5193 2.20719L2.88065 1.9454H2.43265L2.29438 1.51953L2.15796 1.9454H1.70996L2.07131 2.20719L1.93304 2.63307L2.29438 2.36943L2.65757 2.63307L2.5193 2.20719Z"
                    fill="white"
                />
                <path
                    d="M5.03786 2.20719L5.40105 1.9454H4.95305L4.81478 1.51953L4.67651 1.9454H4.22852L4.59171 2.20719L4.45344 2.63307L4.81478 2.36943L5.17797 2.63307L5.03786 2.20719Z"
                    fill="white"
                />
                <path
                    d="M7.55836 2.20719L7.92155 1.9454H7.47356L7.33529 1.51953L7.19702 1.9454H6.74902L7.11221 2.20719L6.97394 2.63307L7.33529 2.36943L7.69663 2.63307L7.55836 2.20719Z"
                    fill="white"
                />
                <path
                    d="M10.0779 2.20719L10.4411 1.9454H9.99309L9.85482 1.51953L9.71655 1.9454H9.26855L9.6299 2.20719L9.49163 2.63307L9.85482 2.36943L10.2162 2.63307L10.0779 2.20719Z"
                    fill="white"
                />
                <path
                    d="M1.25856 3.28814L1.62175 3.0245H1.17375L1.03548 2.59863L0.897214 3.0245H0.449219L0.812408 3.28814L0.674138 3.71401L1.03548 3.45038L1.39683 3.71401L1.25856 3.28814Z"
                    fill="white"
                />
                <path
                    d="M3.77907 3.28814L4.14226 3.0245H3.69426L3.55599 2.59863L3.41772 3.0245H2.96973L3.33107 3.28814L3.19465 3.71401L3.55599 3.45038L3.91734 3.71401L3.77907 3.28814Z"
                    fill="white"
                />
                <path
                    d="M6.2986 3.28814L6.65994 3.0245H6.21379L6.07552 2.59863L5.93725 3.0245H5.48926L5.8506 3.28814L5.71233 3.71401L6.07552 3.45038L6.43687 3.71401L6.2986 3.28814Z"
                    fill="white"
                />
                <path
                    d="M8.81911 3.28814L9.18045 3.0245H8.73246L8.59603 2.59863L8.45592 3.0245H8.00977L8.37111 3.28814L8.23284 3.71401L8.59603 3.45038L8.95738 3.71401L8.81911 3.28814Z"
                    fill="white"
                />
                <path
                    d="M2.5193 4.36822L2.88065 4.10458H2.43265L2.29438 3.67871L2.15796 4.10458H1.70996L2.07131 4.36822L1.93304 4.79409L2.29438 4.53045L2.65757 4.79409L2.5193 4.36822Z"
                    fill="white"
                />
                <path
                    d="M5.03786 4.36822L5.40105 4.10458H4.95305L4.81478 3.67871L4.67651 4.10458H4.22852L4.59171 4.36822L4.45344 4.79409L4.81478 4.53045L5.17797 4.79409L5.03786 4.36822Z"
                    fill="white"
                />
                <path
                    d="M7.55836 4.36822L7.92155 4.10458H7.47356L7.33529 3.67871L7.19702 4.10458H6.74902L7.11221 4.36822L6.97394 4.79409L7.33529 4.53045L7.69663 4.79409L7.55836 4.36822Z"
                    fill="white"
                />
                <path
                    d="M10.0779 4.36822L10.4411 4.10458H9.99309L9.85482 3.67871L9.71655 4.10458H9.26855L9.6299 4.36822L9.49163 4.79409L9.85482 4.53045L10.2162 4.79409L10.0779 4.36822Z"
                    fill="white"
                />
                <path
                    d="M1.25856 5.44645L1.62175 5.18466H1.17375L1.03548 4.75879L0.897214 5.18466H0.449219L0.812408 5.44645L0.674138 5.87232L1.03548 5.61053L1.39683 5.87232L1.25856 5.44645Z"
                    fill="white"
                />
                <path
                    d="M3.77907 5.44645L4.14226 5.18466H3.69426L3.55599 4.75879L3.41772 5.18466H2.96973L3.33107 5.44645L3.19465 5.87232L3.55599 5.61053L3.91734 5.87232L3.77907 5.44645Z"
                    fill="white"
                />
                <path
                    d="M6.2986 5.44645L6.65994 5.18466H6.21379L6.07552 4.75879L5.93725 5.18466H5.48926L5.8506 5.44645L5.71233 5.87232L6.07552 5.61053L6.43687 5.87232L6.2986 5.44645Z"
                    fill="white"
                />
                <path
                    d="M8.81911 5.44645L9.18045 5.18466H8.73246L8.59603 4.75879L8.45592 5.18466H8.00977L8.37111 5.44645L8.23284 5.87232L8.59603 5.61053L8.95738 5.87232L8.81911 5.44645Z"
                    fill="white"
                />
                <path
                    d="M2.5193 6.52751L2.88065 6.26572H2.43265L2.29438 5.83984L2.15796 6.26572H1.70996L2.07131 6.52751L1.93304 6.95338L2.29438 6.69159L2.65757 6.95338L2.5193 6.52751Z"
                    fill="white"
                />
                <path
                    d="M5.03786 6.52751L5.40105 6.26572H4.95305L4.81478 5.83984L4.67651 6.26572H4.22852L4.59171 6.52751L4.45344 6.95338L4.81478 6.69159L5.17797 6.95338L5.03786 6.52751Z"
                    fill="white"
                />
                <path
                    d="M7.55836 6.52751L7.92155 6.26572H7.47356L7.33529 5.83984L7.19702 6.26572H6.74902L7.11221 6.52751L6.97394 6.95338L7.33529 6.69159L7.69663 6.95338L7.55836 6.52751Z"
                    fill="white"
                />
                <path
                    d="M10.0779 6.52751L10.4411 6.26572H9.99309L9.85482 5.83984L9.71655 6.26572H9.26855L9.6299 6.52751L9.49163 6.95338L9.85482 6.69159L10.2162 6.95338L10.0779 6.52751Z"
                    fill="white"
                />
                <path
                    d="M1.25856 7.60748L1.62175 7.34384H1.17375L1.03548 6.91797L0.897214 7.34384H0.449219L0.812408 7.60748L0.674138 8.03335L1.03548 7.76971L1.39683 8.03335L1.25856 7.60748Z"
                    fill="white"
                />
                <path
                    d="M3.77907 7.60748L4.14226 7.34384H3.69426L3.55599 6.91797L3.41772 7.34384H2.96973L3.33107 7.60748L3.19465 8.03335L3.55599 7.76971L3.91734 8.03335L3.77907 7.60748Z"
                    fill="white"
                />
                <path
                    d="M6.2986 7.60748L6.65994 7.34384H6.21379L6.07552 6.91797L5.93725 7.34384H5.48926L5.8506 7.60748L5.71233 8.03335L6.07552 7.76971L6.43687 8.03335L6.2986 7.60748Z"
                    fill="white"
                />
                <path
                    d="M8.81911 7.60748L9.18045 7.34384H8.73246L8.59603 6.91797L8.45592 7.34384H8.00977L8.37111 7.60748L8.23284 8.03335L8.59603 7.76971L8.95738 8.03335L8.81911 7.60748Z"
                    fill="white"
                />
                <path
                    d="M2.5193 8.68755L2.88065 8.42392H2.43265L2.29438 7.99805L2.15796 8.42392H1.70996L2.07131 8.68755L1.93304 9.11342L2.29438 8.84979L2.65757 9.11342L2.5193 8.68755Z"
                    fill="white"
                />
                <path
                    d="M5.03786 8.68755L5.40105 8.42392H4.95305L4.81478 7.99805L4.67651 8.42392H4.22852L4.59171 8.68755L4.45344 9.11342L4.81478 8.84979L5.17797 9.11342L5.03786 8.68755Z"
                    fill="white"
                />
                <path
                    d="M7.55836 8.68755L7.92155 8.42392H7.47356L7.33529 7.99805L7.19702 8.42392H6.74902L7.11221 8.68755L6.97394 9.11342L7.33529 8.84979L7.69663 9.11342L7.55836 8.68755Z"
                    fill="white"
                />
                <path
                    d="M10.0779 8.68755L10.4411 8.42392H9.99309L9.85482 7.99805L9.71655 8.42392H9.26855L9.6299 8.68755L9.49163 9.11342L9.85482 8.84979L10.2162 9.11342L10.0779 8.68755Z"
                    fill="white"
                />
                <path
                    d="M1.25856 9.76861L1.62175 9.50497H1.17375L1.03548 9.0791L0.897214 9.50497H0.449219L0.812408 9.76861L0.674138 10.1926L1.03548 9.93084L1.39683 10.1926L1.25856 9.76861Z"
                    fill="white"
                />
                <path
                    d="M3.77907 9.76861L4.14226 9.50497H3.69426L3.55599 9.0791L3.41772 9.50497H2.96973L3.33107 9.76861L3.19465 10.1926L3.55599 9.93084L3.91734 10.1926L3.77907 9.76861Z"
                    fill="white"
                />
                <path
                    d="M6.2986 9.76861L6.65994 9.50497H6.21379L6.07552 9.0791L5.93725 9.50497H5.48926L5.8506 9.76861L5.71233 10.1926L6.07552 9.93084L6.43687 10.1926L6.2986 9.76861Z"
                    fill="white"
                />
                <path
                    d="M8.81911 9.76861L9.18045 9.50497H8.73246L8.59603 9.0791L8.45592 9.50497H8.00977L8.37111 9.76861L8.23284 10.1926L8.59603 9.93084L8.95738 10.1926L8.81911 9.76861Z"
                    fill="white"
                />
                <path
                    d="M2.5193 10.8487L2.88065 10.5851H2.43265L2.29438 10.1592L2.15796 10.5851H1.70996L2.07131 10.8487L1.93304 11.2727L2.29438 11.0109L2.65757 11.2727L2.5193 10.8487Z"
                    fill="white"
                />
                <path
                    d="M5.03786 10.8487L5.40105 10.5851H4.95305L4.81478 10.1592L4.67651 10.5851H4.22852L4.59171 10.8487L4.45344 11.2727L4.81478 11.0109L5.17797 11.2727L5.03786 10.8487Z"
                    fill="white"
                />
                <path
                    d="M7.55836 10.8487L7.92155 10.5851H7.47356L7.33529 10.1592L7.19702 10.5851H6.74902L7.11221 10.8487L6.97394 11.2727L7.33529 11.0109L7.69663 11.2727L7.55836 10.8487Z"
                    fill="white"
                />
                <path
                    d="M10.0779 10.8487L10.4411 10.5851H9.99309L9.85482 10.1592L9.71655 10.5851H9.26855L9.6299 10.8487L9.49163 11.2727L9.85482 11.0109L10.2162 11.2727L10.0779 10.8487Z"
                    fill="white"
                />
            </g>
        </svg>
    )
}

export default EnglishLogo
